export default "__VITE_ASSET__EUjm1Z7g__"